// Load the analyzers
const heuristicAnalyzer = require("./heuristic-analyzer");

module.exports = [heuristicAnalyzer];



//////////////////
// WEBPACK FOOTER
// ./node_modules/safe-regex/lib/analyzer-family.js
// module id = 1041
// module chunks = 0